import { Component, Input, OnInit } from '@angular/core';

import { PageAction } from '../page-actions/page-actions.component';
import { Models } from '@ibexfusion/models';
import { MessengerService } from '@services/messenger/messenger.service';
import { PackageService } from '@services/packages/package.service';
import QRCode from 'qrcode'
import { MatDialog } from '@angular/material/dialog';
import { QrcodeDialogComponent } from '../../dialogs/qrcode-dialog/qrcode-dialog.component';

@Component({
    selector: 'page-toolbar',
    templateUrl: './page-toolbar.component.html',
    styleUrls: ['./page-toolbar.component.scss'],
    standalone: false
})
export class PageToolbarComponent implements OnInit {

  @Input()
  public title: string;

  @Input()
  public pageActions: PageAction[];

  @Input()
  public subtitle: string;

  public topActionButton;

  profile: Models.Profile;

  constructor(private ms: MessengerService, public dialog: MatDialog, private packageService: PackageService) {
  }

  ngOnInit() {
    this.ms.$activeProfile.subscribe(profile => {
      if (profile) {
        this.profile = profile;
      }
    });
    this.ms.$packageConfiguration.subscribe((config) => {
      this.topActionButton = [];
      if (config && !config.isMasterPackage) {
        if (config.raw.devices && config.raw.devices.length) {
          for (const element of config.raw.devices) {
            switch (element) {
              case 'ibexsmart':
                this.addMobileButtons(this.topActionButton, this.generateLink(config, 'ibexsmart'),
                  this.generateLink(config, 'ibexsmart').replace('preview.', ''), 'ibexsmart');
                break;
              case 'ibextouch':
                this.topActionButton = this.addTouchButtons(this.topActionButton, this.generateLink(config, config.isPortrait ? 'portrait' : 'ibextouch'));
                break;
              case 'ibextablet':
                this.topActionButton = this.addTabletButtons(this.topActionButton, this.generateLink(config, 'ibextablet'));
                break;
              case 'ibexinfo':
                this.topActionButton = this.addInfoButtons(this.topActionButton, this.generateLink(config, 'ibexinfo'));
                break;
              case 'ibextv':
                this.topActionButton = this.addTVButtons(this.topActionButton, this.generateLink(config, 'ibextv'));
                break;
            }
          }
        } else if (config.noTouch2015) {
          if (config.enableIbexApp) {
            this.addMobileButtons(this.topActionButton, this.generateLink(config, 'ibexsmart'),
              this.generateLink(config, 'ibexsmart').replace('preview.', ''), 'ibexsmart');
          }
          if (config.enableIbexTouch) {
            this.topActionButton = this.addTouchButtons(this.topActionButton, this.generateLink(config, config.isPortrait ? 'portrait' : 'ibextouch'));
          }
          if (config.enableIbexInfo) {
            this.topActionButton = this.addInfoButtons(this.topActionButton, this.generateLink(config, 'ibexinfo'));
          }
          if (config.enableIbexTablet) {
            this.topActionButton = this.addTabletButtons(this.topActionButton, this.generateLink(config, 'ibextablet'));
          }
        } else {
          if (!config.isDestination && !config.isScreenPackage && !config.isMasterPackage && !config.isFree && !config.underConstruction) {
            this.packageService.get(config.destinationId).then(result => {
              const link = 'https://web.tweebie.com/' + result.linkName + '/' + config.linkName;
              this.topActionButton = this.addMobileButtons(this.topActionButton, link, link, 'tweebie');
            });
          }
          if (config.enableIbexApp) {
            this.addMobileButtons(this.topActionButton, this.generateLink(config, 'ibexsmart'),
              this.generateLink(config, 'ibexsmart').replace('preview.', ''), 'ibexsmart');
          }
          if (config.screenUuid && config.screenUuid.length) {
            this.topActionButton = this.addTouchButtons(this.topActionButton, 'https://my.ibexfusion.com/app/launch/' + config.screenUuid + '/preview.html');
          }
        }
      } else {
        if (config && config.isScreenPackage && config.enableIbexApp) {
          this.addMobileButtons(this.topActionButton, this.generateLink(config, 'ibexsmart'),
            this.generateLink(config, 'ibexsmart').replace('preview.', ''), 'ibexsmart');
        }
        if (config && config.isScreenPackage && config.enableIbexTouch) {
          this.topActionButton = this.addTouchButtons(this.topActionButton, this.generateLink(config, 'ibextouch'));
        }
      }
    });
  }

  private generateLink(config, type) {
    const conf = config.raw[type === 'ibextv' ? 'ibexTV' : (type === 'ibextablet' ? 'ibexTablet' : (type === 'ibexinfo' ? 'ibexInfo' : (type === 'ibexsmart' ? 'ibexApp' : 'ibexTouch')))];
    let link = conf?.overwritePreviewLink || 'https://preview.' + type + '.ch/' + config.linkName;
    if (type === 'portrait') {
      link = link.replace('preview.portrait', 'portraitpreview.ibextouch');
    }
    return link;
  }

  private addMobileButtons(buttons, link1, link2, type) {
    buttons.push(
      { type, subType: 'link', icon: 'mobile_screen_share', link: link1 },
      { type, subType: 'qrCode', icon: 'qr_code_2', link: link2 }
    );
    return buttons;
  }

  private addTouchButtons(buttons, link) {
    buttons.push({ type: 'screen', subType: 'link', icon: 'touch_app', link });
    return buttons;
  }

  private addTabletButtons(buttons, link) {
    buttons.push({ type: 'tablet', subType: 'link', icon: 'tablet_mac', link });
    return buttons;
  }

  private addInfoButtons(buttons, link) {
    buttons.push({ type: 'info', subType: 'link', icon: 'cast', link });
    return buttons;
  }
  private addTVButtons(buttons, link) {
    buttons.push({ type: 'tv', subType: 'link', icon: 'cast', link });
    return buttons;
  }

  async open(button) {
    if (button?.subType === 'link') {
      window.open(button?.link, '_blank');
    } else if (button?.subType === 'qrCode') {
      try {
        const url = await QRCode.toDataURL(button?.link);
        this.dialog.open(QrcodeDialogComponent, { width: '247px', data: { image: url } });
      } catch (err) {
        console.error(err);
      }
    }
  }
}
